module.exports = __webpack_public_path__ + "img/schoolSpace.79694085.svg";